import React, { useState, useContext } from 'react';
import Button from '@mui/material/Button';

// Context
import ModalContext from '../../../context/ModalContext';

const ConfirmUploadImageSizeModal = ({ modalDetails }) => {
  // Modal Context
  const modalCtx = useContext(ModalContext);

  // Upload Image Loading State
  const [isLoading, setIsLoading] = useState(false);

  // Modal Details
  const { message, onConfirm } = modalDetails;

  // Handle Confirm
  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    handleClose();
    setIsLoading(false);
  };

  // Handle Close
  const handleClose = () => {
    modalCtx.closeModal();
  };

  return (
    <div className="modal-container">
      <div className="modal-header">
        <h3>Image Size Too Small</h3>
      </div>
      <div className="modal-body">
        <span style={{ fontSize: '1.2rem', color: '#000' }}>{message}</span>
        <br />
        <br />
        <span style={{ fontSize: '0.75rem', color: '#555' }}>
          Recommended size: 512x512 pixels
        </span>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={handleClose}>
          CANCEL
        </Button>
        <Button onClick={() => handleConfirm()} disabled={isLoading}>
          {isLoading ? 'UPLOADING...' : 'CONFIRM'}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmUploadImageSizeModal;
